import TakeYourProject from "../../../../src/pages/apis/sign-api/take-your-project-nxt-lvl.md";
import TakeYourProjectCont from "../../../../src/pages/apis/sign-api/take-your-project-content.md";
import PartnershipType from "../../../../src/pages/apis/sign-api/partnership-type.md";
import Usecase from "../../../../src/pages/apis/sign-api/use-case.md";
import OurPartners from "../../../../src/pages/apis/sign-api/our-partners.md";
import OurPartnersTwo from "../../../../src/pages/apis/sign-api/our-partners-two.md";
import { NewsLetterBlade } from "../../../../src/components/news-letter-blade";
import EsealApiAnnouncement from "../../../../src/pages/apis/e-seal-api-announcement.md";
import * as React from 'react';
export default {
  TakeYourProject,
  TakeYourProjectCont,
  PartnershipType,
  Usecase,
  OurPartners,
  OurPartnersTwo,
  NewsLetterBlade,
  EsealApiAnnouncement,
  React
};